// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface OnlineResource
 */
export interface OnlineResource {
  /**
   * valide URL voor online toegang tot (informatie over)de bron.
   */
  url: string;
  /**
   * Protocol voor het downloaden. Indien de url rechtstreeks een dataset levert, dan is dit de mediatype van de dataset. Anders een protocol zoals 'OGC:WMS'.
   */
  protocol: string;
  /**
   * Layer name uit de WMS of WCS, featureType name van een WFS, identifier uit WMTS, of dataset feed title uit Atom.
   */
  name?: string | null;
  /**
   *
   */
  description: OnlineResourceDescriptionEnum;
}

/**
 * @export
 */
export const OnlineResourceDescriptionEnum = {
  AccessPoint: "accessPoint",
  EndPoint: "endPoint",
} as const;
export type OnlineResourceDescriptionEnum =
  (typeof OnlineResourceDescriptionEnum)[keyof typeof OnlineResourceDescriptionEnum];

/**
 * Check if a given object implements the OnlineResource interface.
 */
export function instanceOfOnlineResource(value: object): value is OnlineResource {
  if (!("url" in value) || value["url"] === undefined) return false;
  if (!("protocol" in value) || value["protocol"] === undefined) return false;
  if (!("description" in value) || value["description"] === undefined) return false;
  return true;
}

export function OnlineResourceFromJSON(json: any): OnlineResource {
  return OnlineResourceFromJSONTyped(json, false);
}

export function OnlineResourceFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): OnlineResource {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"],
    protocol: json["protocol"],
    name: json["name"] === undefined ? undefined : json["name"] === null ? null : json["name"],
    description: json["description"],
  };
}

export function OnlineResourceToJSON(json: any): OnlineResource {
  return OnlineResourceToJSONTyped(json, false);
}

export function OnlineResourceToJSONTyped(
  value?: OnlineResource | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    url: value["url"],
    protocol: value["protocol"],
    name: value["name"],
    description: value["description"],
  };
}
